import { Component, Input, NgZone, ElementRef, ViewChild, OnInit, InjectionToken, Inject } from '@angular/core'
import { first } from 'rxjs/operators'

import { MapCurrentLocationAdapter } from './map-current-location-adapter'
import { mapCurrentLocationFactory } from './map-current-location-factory'
import { DataService } from '@shared/services/data.service'
import { LatLng } from '@shared/models/latlng.model'

export const MAP_CURRENT_LOCATION_APAPTER = new InjectionToken<MapCurrentLocationAdapter>('MAP_CURRENT_LOCATION_APAPTER')

@Component({
  selector: 'lin-map-current-location',
  template: ` <div #mapCurrentLocation class="map"></div> `,
  styles: [
    `
      .map {
        width: 100%;
        height: 100%;
      }
    `,
  ],
  providers: [
    {
      provide: MAP_CURRENT_LOCATION_APAPTER,
      useFactory: mapCurrentLocationFactory,
      deps: [DataService],
    },
  ],
  standalone: false,
})
export class MapCurrentLocationComponent implements OnInit {
  @Input() latitude: number
  @Input() longitude: number

  @ViewChild('mapCurrentLocation', { static: true }) mapCurrentLocation: ElementRef

  constructor(
    @Inject(MAP_CURRENT_LOCATION_APAPTER) private mapCurrentLocationAdapter: MapCurrentLocationAdapter,
    private zone: NgZone,
  ) {}

  ngOnInit() {
    this.initMap()
  }

  initMap() {
    this.mapCurrentLocationAdapter.isScriptLoaded$.subscribe(() => {
      const coordinate: LatLng = { lat: this.latitude, lng: this.longitude }
      this.zone.runOutsideAngular(() => this.mapCurrentLocationAdapter.initMap(this.mapCurrentLocation.nativeElement))
      this.mapCurrentLocationAdapter.fitBounds(coordinate)
      this.mapCurrentLocationAdapter.setMarker(coordinate)
    })
  }
}
